import { Box } from "@mui/material";
import Blob from "../assets/blobs.svg";
import Plain from "../assets/plainbg.svg"
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { RootState } from "../types/store.tsx";
import AppConstants from "../constants/app-constants.jsx";

export default function LobbyLayout({ children }: { children: React.ReactNode }) {
    const [bgTheme, setBgTheme] = useState<string>(Blob);
    const lobby = useSelector((state: RootState) => state.page.lobby);
    const settings = useSelector((state: RootState) => state.settings);

    useEffect(() => {
        if (lobby?.state === AppConstants.STATE_LOBBY) {
            setBgTheme(Blob);
        } else if (lobby?.state === AppConstants.STATE_DONE || lobby?.state === AppConstants.STATE_SLOTS) {
            setBgTheme(Plain);
        } else if (lobby?.current_question?.category > 0) {
            const category = settings.categories.find((cat) => cat.id === lobby.current_question.category);
            if (category?.background && category.background !== bgTheme) {
                setBgTheme(category.background);
            }
        }
    }, [lobby, settings]);

    return (
        <Box
            sx={{
                background: `linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ), url("${bgTheme}")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100dvh",
                width: "100vw",
                display: "flex",
                flexDirection: "column",
            }}
            id="MyLobbyLayout"
        >
            {children}
        </Box>
    );
}